import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./ProductDeliveryReturns.module.scss";
import { ReturnsExclusions } from "../ReturnsExclusions/ReturnsExclusions";

export type Props = {
  browsePageHierarchy: Array<{ categoryId: string }>;
  showExclusionsMessaging?: boolean;
};

export const ProductDeliveryReturns = ({
  browsePageHierarchy,
  showExclusionsMessaging = false,
}: Props) => {
  return (
    <div className={styles.returns} data-testid="delivery:returns">
      <h3 data-testid="delivery:returns:title">Returns</h3>
      {showExclusionsMessaging && (
        <ReturnsExclusions browsePageHierarchy={browsePageHierarchy} />
      )}

      <div className={styles.returnsCopy}>
        <p>
          Return small or medium items by post or to John Lewis &amp; Partners
          and Waitrose &amp; Partners shops.
        </p>
        <p className={styles.homeCollection}>
          Large items (delivered by two people, such as appliances and
          furniture) can be returned using our{" "}
          <a href="/customer-services/returns/how-do-i-return-an-item/home-collection">
            Home Collection service
          </a>
          .
        </p>
        <p>
          You can also return a Click &amp; Collect order to where you collected
          it.
        </p>
      </div>

      <div className={styles.buttons}>
        <SecondaryButton tag="a" href="/customer-services/delivery-information">
          More about delivery &amp; collection
        </SecondaryButton>
        <SecondaryButton tag="a" href="/customer-services/returns">
          More about returns &amp; refunds
        </SecondaryButton>
      </div>
    </div>
  );
};
